import {Injectable} from "@angular/core";
import {UUID} from "angular2-uuid";

/**
 * This service provides storage and retrieval of the app user id
 */
@Injectable()
export class AppUserService {
    public static readonly LOCAL_STORAGE_KEY: string = "appUserId";

    private readonly storageKey: string;

    constructor() {
        console.log("--- AppUserService");

        this.storageKey = AppUserService.LOCAL_STORAGE_KEY;
    }

    public getAppUserId(): string {
        let appUserId: string = localStorage.getItem(this.storageKey);
        if (appUserId == null) {
            appUserId = UUID.UUID();
            localStorage.setItem(this.storageKey, appUserId);
        }

        return appUserId;
    }

    public updateAppUserId(appUserId: string): void {
        localStorage.setItem(this.storageKey, appUserId);
    }
}



// WEBPACK FOOTER //
// ./src/app/identity/app-user.service.ts